// @ts-nocheck
import React, { useState, useCallback } from 'react';
import { TableCell, IconButton, useTheme, alpha } from '@mui/material';
import { ReactComponent as AddIcon } from '../../../../assets/Icons/lucideIcons/plus.svg';
import PropTypes from 'prop-types';

import { useTableState } from '../../context/TableSchemaBuilderContext';

const CornerCell = ({
  onAddRowBefore,
  onAddColumnBefore,
  heightFromVirtualized = 24,
}) => {
  const { config } = useTableState();
  const theme = useTheme();

  const [showButtons, setShowButtons] = useState(false);
  const readOnly = config?.readOnly ?? false;
  const editMode = config?.editMode ?? false;

  const handleMouseEnter = useCallback(() => {
    // Show buttons only if the table is not read-only
    if (editMode || readOnly || config?.fromConstAttributeFeature) {
      return;
    }
    setShowButtons(true);
  }, [editMode, readOnly, setShowButtons, config?.fromConstAttributeFeature]);

  const handleMouseLeave = useCallback(() => {
    // Show buttons only if the table is not read-only
    if (editMode || readOnly || config?.fromConstAttributeFeature) {
      return;
    }
    setShowButtons(false);
  }, [editMode, readOnly, setShowButtons, config?.fromConstAttributeFeature]);

  const handleAddColumnBefore = useCallback(() => {
    onAddColumnBefore(0);
  }, [onAddColumnBefore]);

  const handleAddRowBefore = useCallback(() => {
    onAddRowBefore(0);
  }, [onAddRowBefore]);

  const renderAddButtons = useCallback(() => {
    if (!showButtons) {
      return null;
    }

    return (
      <>
        <IconButton
          className="corner-add-buttons"
          size="small"
          onClick={handleAddColumnBefore}
          sx={{
            position: 'absolute',
            right: -6,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 12,
            height: 12,
            backgroundColor: theme?.palette?.other?.white,
            border: `1px solid ${alpha(theme?.palette?.primary?.main, 0.1)}`,
            opacity: 0,
            transition: 'opacity 0.2s',
            zIndex: 3,
            padding: '2px',
            '&:hover': {
              backgroundColor: theme?.palette?.other?.hoverBackground,
            },
          }}
        >
          <AddIcon
            width={16}
            height={16}
            style={{ color: theme?.palette?.other?.addIconColor }}
          />
        </IconButton>

        <IconButton
          className="corner-add-buttons"
          size="small"
          onClick={handleAddRowBefore}
          sx={{
            position: 'absolute',
            left: '50%',
            bottom: -6,
            transform: 'translateX(-50%)',
            width: 12,
            height: 12,
            backgroundColor: theme?.palette?.other?.white,
            border: `1px solid ${alpha(theme?.palette?.primary?.main, 0.1)}`,
            opacity: 0,
            transition: 'opacity 0.2s',
            zIndex: 3,
            padding: '2px',
            '&:hover': {
              backgroundColor: theme?.palette?.other?.hoverBackground,
            },
          }}
        >
          <AddIcon
            sx={{
              fontSize: '16px',
              color: theme?.palette?.other?.addIconColor,
            }}
          />
        </IconButton>
      </>
    );
  }, [showButtons, handleAddColumnBefore, handleAddRowBefore]);

  return (
    <TableCell
      sx={{
        padding: 0,
        backgroundColor: alpha(theme?.palette?.primary?.main, 0.05),
        position: 'sticky',
        top: 0,
        left: 0,
        zIndex: 6,
        width: 50,
        minWidth: 50,
        height: heightFromVirtualized || 24,
        borderRight: `1px solid ${alpha(theme?.palette?.primary?.main, 0.2)}`,
        borderBottom: `1px solid ${alpha(theme?.palette?.primary?.main, 0.2)}`,
        '&:hover': {
          '& .corner-add-buttons': {
            opacity: 1,
          },
        },
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {renderAddButtons()}
    </TableCell>
  );
};

CornerCell.propTypes = {
  onAddRowBefore: PropTypes.func.isRequired,
  onAddColumnBefore: PropTypes.func.isRequired,
  heightFromVirtualized: PropTypes.number,
};

export default CornerCell;
